const CarpartComponent = () => import('@/views/WareHouse/CarPart/CarPartView')

export default [
    {
        path:'/CarpartIndex',
        name:'CarpartComponent',
        component:CarpartComponent
    }
]